<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help lang="fr" [file]="pathHelpFile" [width]="800"></yo-help>
      <div class="mg-l-5 mg-r-5">
        <yo-button
          class="mg-r-10"
          iconClass="fa fa-plus"
          [theme]="ButtonThemeEnum.ADD"
          label="CRÉER"
          (onClick)="openDialogEdition(null)"
          tooltip="Créer un allergène">
        </yo-button>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="after" class="mg-r-16">
    <yo-button
      (onClick)="exportXslx()"
      iconClass="fas fa-download"
      [theme]="ButtonThemeEnum.DEFAULT"
      class="mg-r-5"
      tooltip="Exporter les éléments format Excel">
    </yo-button>
    <yo-button
      iconClass="fas fa-upload"
      [theme]="ButtonThemeEnum.DEFAULT"
      class="mg-r-5"
      id="import-excel-file"
      tooltip="Importer les éléments à partir d'une feuille Excel">
    </yo-button>
    <yo-button
      iconClass="fas fa-trash"
      [theme]="ButtonThemeEnum.DELETE_INNER"
      (onClick)="deleteValues()"
      [disabled]="!canDelete()"
      tooltip="Supprimer les éléments sélectionnés">
    </yo-button>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="allergenes"
  keyExpr="id"
  class="data-grid"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  columnResizingMode="widget"
  #grid>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxi-column dataField="id" caption="Actions"
              [width]="79"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="site" caption="Site"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              cellTemplate="actionsSiteTemplate"
              [calculateCellValue]="calculateSiteValue">
  </dxi-column>
  <dxi-column dataField="logo" caption="Logo"
              [width]="79"
              cssClass="text-align-center vertical-align-middle"
              [allowFiltering]="false"
              cellTemplate="logoTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="appellationInformationConsommateur" caption="Appellation INCO"
              width="28%"
              title="Appellation Information Consommateur"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="code" caption="Code"

              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="actif" caption="Actif"
              width="9.5%"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER"
      (onClick)="openDialogEdition(cell.row.data)"
      [iconClass]="allergenesSvc.canModify(cell.row.data)? 'fa fa-edit' : 'fas fa-eye'"
      [tooltip]="allergenesSvc.canModify(cell.row.data)? 'Modifier l\'allergène' : 'Voir l\'allergène'">
    </yo-button>
  </div>

  <div *dxTemplate="let cell of 'actionsSiteTemplate'">
    <yo-site [siteLibelle]="cell.row.data?.site?.libelle" [siteId]="cell.row.data?.site?.id"></yo-site>
  </div>

  <div *dxTemplate="let cell of 'logoTemplate'">
    <img [src]="getLogoUrl(cell.row.data)"
         (click)="openImagePopup(cell.row.data)"
         (error)="allergenesSvc.onImageError($event)"
         class="cursor rounded image-keep-ratio thumb-image">
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} allergènes">
  </dxo-pager>

</dx-data-grid>

<dx-tooltip
  #importTooltip
  target="#import-excel-file"
  showEvent="click"
  hideOnOutsideClick="true"
  wrapperAttr="true"
  [wrapperAttr]="{ class: 'custom-tooltip' }">
  hidden>
  <div *dxTemplate="let data = data of 'content'">
    <div class="custom-file-uploader">
      <input type="file"
             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
             (change)="importXslx($event)">
    </div>
  </div>
</dx-tooltip>

<yo-allergeneEditionDialog></yo-allergeneEditionDialog>

<dx-popup
  [showTitle]="true"
  [title]="imageTitle"
  class="text-align-center"
  [(visible)]="displayImagePopup"
  [height]="347"
  [width]="298"
  [resizeEnabled]="false"
  [showCloseButton]="true"
  (close)="closeImagePopup()">
  <img class="image-keep-ratio wide-image"
       [src]="imagePath"
       (error)="allergenesSvc.onImageError($event)">
</dx-popup>

<dx-popup
  [showTitle]="true"
  title="Lignes n'ayant pas été importées"
  [(visible)]="displayImportPopupErrors"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeErrors()"
>
  <label>Les éléments non présents dans cette liste ont bien été importés.</label>
  <dx-data-grid
    [dataSource]="errors"
    keyExpr="infosLine"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
  >
    <dxi-column dataField="infosLine" caption="Ligne non importée" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxi-column dataField="labelsError" caption="Erreur(s)" [allowFiltering]="false"></dxi-column>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
</dx-popup>


<dx-popup
  [showTitle]="true"
  title="Lignes n'ayant pas été supprimées"
  [(visible)]="displayDeletePopupErrors"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (close)="closeErrors()"
>
  <label>Les éléments non présents dans cette liste ont bien été supprimés.</label>
  <dx-data-grid
    [dataSource]="errors"
    keyExpr="infosLine"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
  >
    <dxi-column dataField="infosLine" caption="Ligne non supprimée" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
</dx-popup>
